import BattleInfo from "../components/BattleInfo";

const Battle = () => <BattleInfo />;

export default Battle;
